import React, {Component} from 'react';
import {Row, Col, Tooltip, Card, CardHeader, CardBody, Button, CardFooter, Table, Badge, ButtonToolbar, CardTitle,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem} from 'reactstrap';
import { ajaxWrapperGet } from '../../../utils/deviceAPI';
import { isDeviceOnline } from '../../../utils/isDeviceOnline';
import LoadingIndicator from '../../../utils/LoadingIndicator'
import DeviceOffline from '../DeviceMessages/DeviceOffline';



//templates
import BeaverCreek from './Templates/BeaverCreek';
import Template from './Templates/Template';


class Overview extends Component {
    constructor(props) {
        super(props);
        this.state = { data: [
            {

                initializer: 0
            },
            {
                initializer: 0,
            }

        ],
            loading: true,
            overViewZoomLevel: 1,
            tooltipOpen: [false, false, false],
            device: ""
        };
    }
    componentDidMount() {
        this.setData();
    }
    componentWillReceiveProps(nextProps) {

        const dev = this.props.match.params.dev.replace('device_','');
        const newDev = nextProps.match.params.dev.replace('device_','');
        if (dev !== newDev ) {
            this.setData(newDev);
        }
    }
    componentWillUnmount(){

    }
    setData(device = this.props.match.params.dev.replace('device_','')) {
        ajaxWrapperGet('/api/deviceLayoutData',device).then((data) => {
            console.log(data);
            this.setState({
                data,
                loading: false,
                device: device
            });
        });
    }


    render() {

        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        if (!isDeviceOnline(this.props.uidata.alarms,this.props.match.params.dev.replace('device_',''))) {
            return (
                <DeviceOffline/>
            )
        }
        let templateName = this.state.data.templateData[0]['header'][0]['templateName'];
        if (templateName.toString() === 'BeaverCreek') { return <BeaverCreek device={this.state.device}/> }
        else { return <Template
            template={this.state.data.templateLayout}
            device={this.state.device}
        /> }
    }
}

export default Overview;





// WEBPACK FOOTER //
// ./src/views/site/Overview/Overview.js